var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.3 67.5",
    style: {
      enableBackground: "new 0 0 67.3 67.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:url(#SVGID_33_);}\r\n\t.st33{fill:url(#SVGID_34_);}\r\n\t.st34{fill:url(#SVGID_35_);}\r\n\t.st35{fill:url(#SVGID_36_);}\r\n\t.st36{fill:url(#SVGID_37_);}\r\n\t.st37{fill:url(#SVGID_38_);}\r\n\t.st38{fill:url(#SVGID_39_);}\r\n\t.st39{fill:url(#SVGID_40_);}\r\n\t.st40{fill:url(#SVGID_41_);}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:url(#SVGID_44_);}\r\n\t.st44{fill:url(#SVGID_45_);}\r\n\t.st45{fill:url(#SVGID_46_);}\r\n\t.st46{fill:url(#SVGID_47_);}\r\n\t.st47{fill:url(#SVGID_48_);}\r\n\t.st48{fill:url(#SVGID_49_);}\r\n\t.st49{fill:url(#SVGID_50_);}\r\n\t.st50{fill:url(#SVGID_51_);}\r\n\t.st51{fill:url(#SVGID_52_);}\r\n\t.st52{fill:url(#SVGID_53_);}\r\n\t.st53{fill:url(#SVGID_54_);}\r\n\t.st54{fill:url(#SVGID_55_);}\r\n\t.st55{fill:url(#SVGID_56_);}\r\n\t.st56{fill:url(#SVGID_57_);}\r\n\t.st57{fill:url(#SVGID_58_);}\r\n\t.st58{fill:url(#SVGID_59_);}\r\n\t.st59{fill:url(#SVGID_60_);}\r\n\t.st60{fill:url(#SVGID_61_);}\r\n\t.st61{fill:url(#SVGID_62_);}\r\n\t.st62{fill:url(#SVGID_63_);}\r\n\t.st63{fill:url(#SVGID_64_);}\r\n\t.st64{fill:url(#SVGID_65_);}\r\n\t.st65{fill:url(#SVGID_66_);}\r\n\t.st66{fill:url(#SVGID_67_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4029,
    y1: 33.765,
    x2: 66.9471,
    y2: 33.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,63.4c-3.8-1.7-7.3-4-10.2-7c-3-3-5.2-6.5-6.9-10.3c-1.7-4-2.5-8.2-2.5-12.6C1.4,29.2,2.3,25,4,21 c1.7-3.8,4-7.3,7-10.2S17.5,5.6,21.3,4c4-1.7,8.2-2.5,12.6-2.5c4.4,0,8.6,0.9,12.6,2.6c3.8,1.7,7.3,4,10.2,7s5.2,6.5,6.9,10.3 c1.7,4,2.5,8.2,2.5,12.6c0,4.4-0.9,8.6-2.6,12.6c-1.7,3.8-4,7.3-7,10.2c-3,3-6.4,5.2-10.3,6.9c-4,1.7-8.2,2.5-12.6,2.5 S24.9,65.2,20.9,63.4 M20.9,3c-4,1.7-7.5,4-10.6,7.1c-3.1,3-5.5,6.6-7.2,10.5c-1.7,4.1-2.7,8.5-2.7,12.9c0,4.5,0.8,8.9,2.6,13 c1.7,4,4,7.5,7.1,10.6c3,3.1,6.6,5.5,10.5,7.2c4.1,1.7,8.4,2.7,12.9,2.7s8.9-0.8,12.9-2.6c4-1.7,7.5-4,10.6-7.1 c3.1-3.1,5.5-6.6,7.2-10.5c1.7-4.1,2.7-8.4,2.7-12.9s-0.8-8.9-2.6-13c-1.7-4-4-7.5-7.1-10.6c-3.1-3.1-6.6-5.5-10.5-7.2 c-4.1-1.7-8.4-2.7-12.9-2.7C29.4,0.5,25,1.4,20.9,3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1124,
    y1: 37.9173,
    x2: 40.2987,
    y2: 37.9173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.9,19.3c0,0-0.7,0.1-0.8,0.7V20l28.2,36.3l0,0c0.3,0.3,0.6,0.2,0.8,0.1c0.2-0.2,0.3-0.7-0.1-1.1 c-0.4-0.5-27.8-35.6-28.1-36H11.9L11.9,19.3z M11.8,19.6c1.6,2,27.6,35.5,28.1,36c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.3,0-0.4-0.1c0,0-28.1-36.1-28.1-36.2C11.5,19.7,11.7,19.7,11.8,19.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4431,
    y1: 19.2067,
    x2: 11.6702,
    y2: 19.2067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,19.2c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6c0-0.2-0.1-0.3-0.2-0.4l-0.4-0.2 C10.7,18.6,10.4,18.9,10.4,19.2 M11,19.5c-0.2,0-0.3-0.2-0.3-0.3s0.2-0.3,0.3-0.3l0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3 C11.3,19.4,11.2,19.5,11,19.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.1832,
    y1: 35.3547,
    x2: 14.2918,
    y2: 35.3547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,26.2c-0.3,1.2-1,3-0.8,5.2c0.9,1.5,3.9,3.6,4,4.2c0.1,0.7-0.1,1.9-1.6,3.3C8.1,40.3,8,41,8,41.9 c0.2,1.2,1.5,1.5,2.1,2.6c1.2-1.3,4.1-4.7,4.1-4.7s-2.6-4.1-3.5-5.5c-0.3-0.6,0.1-1.7,0.4-2C9.1,29.2,8.6,27.8,8,26.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5627,
    y1: 44.5031,
    x2: 23.2192,
    y2: 44.5031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.7,36.3c-0.4,0.7-1.5,2-0.1,3.4c1.5,1.4,2.7,2.7,2.7,2.7s0.3,0.4-0.2,0.8c-0.4,0.4-3.7,2.8-4.6,5.7 c0.9,1.7,2.7,3.8,3.7,3.8c0.3,0.1-0.3-1.7,0.6-2.8c0.9-1.1,5.5-4,6.1-5.2c0.4-0.7,0.3-1.1,0.2-2c-0.2-0.6-0.7-0.4-1.2,0 c-0.6,0.5-1.1,0.9-1.7,1.2c-0.7,0.4-4.1-0.2-0.8-4.7C16.9,38.1,14.7,36.3,14.7,36.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.0446,
    y1: 29.6653,
    x2: 23.6069,
    y2: 29.6653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11.3,20c-1.2,1.2-2.8,4.5-3.2,6.2c0.6,2.1,3.3,9.4,11.5,13.2c0.9-1.3,2.6-2.8,4.1-3.3 C20,34.5,14,27.4,11.3,20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.7735,
    y1: 41.8274,
    x2: 21.6547,
    y2: 41.8274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.8,40.2c-2.6,4.7,0.2,3.4,1.8,1.9L19.8,40.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.1084,
    y1: 46.7057,
    x2: 12.5627,
    y2: 46.7057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.1,44.5c0.1,0.3,2.3,4.1,2.5,4.4C12.4,48.6,10.2,44.9,10.1,44.5L10.1,44.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.9893,
    y1: 38.0188,
    x2: 56.5722,
    y2: 38.0188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.7,19.6c-0.3,0.3-28,35.3-28.4,35.7C27,55.5,27,55.8,27,56c0.1,0.2,0.2,0.4,0.4,0.4 c0.1,0.1,0.3,0.1,0.6-0.2l0,0l28.6-36v-0.1c-0.1-0.6-0.7-0.7-0.8-0.7L55.7,19.6L55.7,19.6z M27.5,56.2c-0.1,0-0.2-0.1-0.2-0.2 c0-0.1,0-0.1,0-0.1c0-0.1,0.1-0.3,0.2-0.3c0.4-0.4,26.8-33.6,28.4-35.6c0.1,0.1,0.3,0.1,0.4,0.4c-0.1,0.1-28.5,35.9-28.5,35.9 C27.6,56.2,27.5,56.2,27.5,56.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0702,
    y1: 19.4298,
    x2: 57.2974,
    y2: 19.4298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M56.1,19.4L56.1,19.4c0,0.3,0.3,0.6,0.6,0.6l0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4l-0.4-0.2 C56.3,18.8,56.1,19.1,56.1,19.4 M56.7,19.1l0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3s-0.1,0.2-0.1,0.3l-0.2,0.1c-0.2,0-0.3-0.2-0.3-0.3 C56.3,19.3,56.5,19.1,56.7,19.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6722,
    y1: 17.3102,
    x2: 60.1979,
    y2: 17.3102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M59.9,15.4c-0.3,0.2-3.4,2.1-3.2,3.4c0-0.1,0.1,0.3,0.1,0.3c0.1,0.2,0.3,0.3,0.6,0.4c1.2,0,2.6-3.5,2.7-3.8 l0.1-0.4L59.9,15.4z M57.4,19.1c-0.3-0.1-0.4-0.2-0.4-0.3l0,0c0-0.1,0-0.1,0-0.1c0-0.9,1.7-2.2,2.7-2.8 C59.1,17,58.1,19.1,57.4,19.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1697,
    y1: 35.6057,
    x2: 60.3917,
    y2: 35.6057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M59.6,26.5c0.3,1.2,0.9,3,0.8,5.2c-0.9,1.5-4,3.6-4.1,4.2c-0.1,0.7,0.1,1.9,1.6,3.3c1.5,1.4,1.5,2.1,1.5,3 c-0.2,1.2-1.5,1.4-2.1,2.6c-1.2-1.3-4.1-4.7-4.1-4.7s2.6-4.1,3.6-5.5c0.3-0.6-0.1-1.7-0.4-2C58.5,29.5,59,28.1,59.6,26.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.2515,
    y1: 44.7262,
    x2: 54.7873,
    y2: 44.7262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.8,36.5c0.4,0.7,1.5,2,0,3.4c-1.5,1.4-2.7,2.7-2.7,2.7s-0.3,0.4,0.2,0.8c0.4,0.4,3.7,2.8,4.6,5.7 c-0.9,1.7-2.7,3.7-3.7,3.8c-0.3,0.1,0.3-1.7-0.6-2.8c-0.9-1.1-5.5-4-6-5.2c-0.4-0.7-0.3-1.1-0.2-2c0.3-0.6,0.7-0.4,1.2,0 c0.6,0.5,1.1,0.9,1.7,1.2c0.7,0.4,4.1-0.1,0.8-4.7C50.6,38.3,52.8,36.5,52.8,36.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9104,
    y1: 29.8326,
    x2: 59.5843,
    y2: 29.8326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M56.4,20.2c1.2,1.2,2.7,4.5,3.2,6.2C59,28.5,56.1,35.8,48,39.5c-0.9-1.3-2.6-2.8-4.1-3.3 C47.5,34.7,53.6,27.6,56.4,20.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8069,
    y1: 41.9948,
    x2: 48.6536,
    y2: 41.9948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M47.6,40.3c2.5,4.7-0.3,3.4-1.8,1.9L47.6,40.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.7873,
    y1: 46.9567,
    x2: 57.2974,
    y2: 46.9567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M54.8,49.1c0.2-0.3,2.4-4,2.5-4.3l0,0C57.2,45.1,55,48.8,54.8,49.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.9939,
    y1: 32.9004,
    x2: 39.727,
    y2: 32.9004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39.7,32.9c0,1.4-0.6,2.5-1.4,2.5c-0.7,0-1.3-1.1-1.3-2.5c0-1.4,0.6-2.5,1.4-2.5 C39.1,30.4,39.7,31.5,39.7,32.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.1729,
    y1: 32.5658,
    x2: 31.3123,
    y2: 32.5658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M31.1,32.9c-0.4,1.6-1.3,2.6-2.1,2.5c-0.8-0.2-1.1-1.6-0.7-3.2c0.4-1.6,1.3-2.6,2.1-2.5 C31.2,30,31.5,31.4,31.1,32.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.918,
    y1: 33.3188,
    x2: 33.6471,
    y2: 33.3188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M33.6,33.3l-1.6-0.1c0,0-0.1,0.1-0.2,0.2c0.2,0,0.9,0,1.6,0C33.5,33.3,33.6,33.3,33.6,33.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.9818,
    y1: 36.7814,
    x2: 35.1531,
    y2: 36.7814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M34,36.7c0.1,0.3,0.2,0.5,0.4,0.4c0.4,0,0.6-0.3,0.7-0.7c-0.2,0-0.6,0.1-1.2,0.1C34,36.6,34,36.7,34,36.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2567,
    y1: 48.658,
    x2: 33.8702,
    y2: 48.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M33.3,48.8c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1h0.1c0.2,0,0.2,0,0.3,0c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.2,0-0.2,0-0.4,0l0,0C33.4,48.7,33.3,48.7,33.3,48.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.2526,
    y1: 45.5108,
    x2: 33.4798,
    y2: 45.5108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M33,45.8c0.2,0,0.3-0.2,0.5-0.5c-0.6,0.1-1,0.1-1.2,0.1C32.5,45.6,32.7,45.8,33,45.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3682,
    y1: 33.4582,
    x2: 33.9818,
    y2: 33.4582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M33.5,33.4c-0.1,0.1-0.1,0.1-0.1,0.2c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0.1c0.2,0,0.2,0,0.3,0 c-0.1-0.1-0.1-0.1-0.1-0.2C33.7,33.4,33.7,33.4,33.5,33.4L33.5,33.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.926,
    y1: 48.9412,
    x2: 35.0974,
    y2: 48.9412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M34,48.8c0.1,0.3,0.2,0.5,0.4,0.4c0.4,0,0.6-0.3,0.7-0.7c-0.2,0-0.6,0.1-1.2,0.1C33.9,48.8,33.9,48.8,34,48.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4798,
    y1: 45.1439,
    x2: 34.0933,
    y2: 45.1439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M33.5,45.3c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0,0.2,0,0.3,0C34,45.1,34,45.1,34,45 c-0.2,0-0.2,0-0.4,0l0,0C33.5,45.1,33.5,45.2,33.5,45.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.0335,
    y1: 39.2034,
    x2: 33.6471,
    y2: 39.2034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M33,39.3c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0.1c0.2,0,0.2,0,0.3,0c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.2,0-0.2,0-0.4,0l0,0C33.1,39.2,33.1,39.2,33,39.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.7029,
    y1: 39.5102,
    x2: 34.8742,
    y2: 39.5102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M33.8,39.3c0.1,0.3,0.2,0.5,0.4,0.5c0.4,0,0.6-0.3,0.7-0.7C34.7,39.2,34.3,39.2,33.8,39.3 C33.7,39.3,33.7,39.3,33.8,39.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0853,
    y1: 36.9201,
    x2: 33.3124,
    y2: 36.9201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M32.8,37.2c0.2,0,0.3-0.2,0.5-0.5c-0.6,0.1-1,0.1-1.2,0.1C32.4,36.9,32.6,37.2,32.8,37.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1491,
    y1: 45.3713,
    x2: 35.3205,
    y2: 45.3713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M34.2,45.3c0.1,0.3,0.2,0.5,0.4,0.4c0.4,0,0.6-0.3,0.7-0.7c-0.2,0-0.6,0.1-1.2,0.1 C34.1,45.2,34.1,45.3,34.2,45.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3124,
    y1: 36.5539,
    x2: 33.9818,
    y2: 36.5539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M33.3,36.7c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1l0.1-0.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.3,0 c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2,0-0.2,0-0.4,0l0,0C33.4,36.6,33.4,36.6,33.3,36.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.8064,
    y1: 39.566,
    x2: 33.0335,
    y2: 39.566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M33,39.3c-0.6,0.1-1,0.1-1.2,0.1c0.2,0.2,0.4,0.4,0.7,0.4C32.7,39.8,32.9,39.6,33,39.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0295,
    y1: 49.0249,
    x2: 33.2567,
    y2: 49.0249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M32.8,49.3c0.2,0,0.3-0.2,0.5-0.5c-0.6,0.1-1,0.1-1.2,0.1C32.3,49.1,32.5,49.3,32.8,49.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0853,
    y1: 33.8523,
    x2: 33.3124,
    y2: 33.8523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M32.8,34.1c0.2,0,0.3-0.2,0.5-0.5c-0.6,0.1-1,0.1-1.2,0.1C32.4,33.9,32.6,34.2,32.8,34.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.5913,
    y1: 51.921,
    x2: 34.2049,
    y2: 51.921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M34.1,51.8c-0.2,0-0.2,0-0.4,0l0,0c-0.1,0.1-0.1,0.1-0.1,0.2c0.2,0,0.2,0,0.3,0c0,0,0,0,0-0.1 c0,0,0.1,0,0.1,0.1c0.2,0,0.2,0,0.3,0C34.2,51.9,34.2,51.8,34.1,51.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.42,
    y1: 52.3115,
    x2: 33.5913,
    y2: 52.3115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M33.1,52.6c0.2,0,0.3-0.2,0.5-0.5c-0.6,0.1-1,0.1-1.2,0.1C32.6,52.3,32.9,52.6,33.1,52.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.2607,
    y1: 52.1763,
    x2: 35.432,
    y2: 52.1763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M34.3,52.1c0.1,0.3,0.2,0.5,0.4,0.4c0.4,0,0.6-0.4,0.7-0.7c-0.2,0-0.6,0.1-1.2,0.1C34.3,52,34.3,52,34.3,52.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8582,
    y1: 45.5189,
    x2: 36.4918,
    y2: 45.5189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M35.9,56.5c-0.1-0.9-0.1-3.9-0.1-3.9s0.4-0.4,0.4-0.8s-0.5-0.3-0.6-0.8c-0.1-0.4,0.4-0.6,0.4-0.9 c-0.1-0.3-0.4-0.3-0.4-0.7c0-0.4,0.6-0.7,0.4-1.1c-0.2-0.3-0.4-0.6-0.4-1.3c0-0.7,0.8-1.2,0.5-1.7c-0.3-0.4-0.5-1.1-0.5-1.7 c0-0.6,0.1-1.3,0.3-1.7c0.1-0.6-0.3-0.1-0.3-0.8c-0.1-0.7,0.1-1.1,0.1-1.5c0-0.3,0.4-0.2,0.3-0.7s-0.4-0.4-0.4-1.1 c0-0.7,0.2-1.1,0.2-1.3c0-0.2,0.5-0.2,0.2-0.7c-0.3-0.4-0.3-1.2-0.2-1.6c0.1-0.4-0.1-0.9-0.1-0.9l-2-0.1c0.1,0,0.1,0.1,0.1,0.1 c0.6,0,1.3,0,1.3,0c0,0.1,0,0.1,0,0.1c0.1,0,0.2,0,0.2,0c-0.1,0.3-0.2,0.9-0.9,0.9c-0.4,0-0.6-0.3-0.7-0.6c0,0-0.1-0.1-0.1-0.2 c-0.1,0-0.1,0-0.1,0c-0.2,0.5-0.5,0.7-0.8,0.8c-0.3,0.1-0.7-0.3-0.9-0.5l-0.1-0.1h0.3l0,0l-0.2-0.2c-0.1,0.2-0.2,0.6,0.3,1.3 c0.4,0.6,0,0.9-0.2,1.2c-0.1,0.2-0.2,0.5-0.2,0.8c0,0,0.2,0,0.3,0l0,0l-0.3-0.3c0,0,0.8,0,1.6,0c0.1-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.3,0c0,0.1,0,0.1,0,0.1c0.1,0,0.2,0,0.2,0c-0.1,0.3-0.2,0.9-0.9,0.9c-0.4,0-0.6-0.3-0.7-0.6 c0,0-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.1,0c-0.2,0.5-0.5,0.7-0.8,0.8c-0.3,0.1-0.7-0.3-0.9-0.5l-0.1-0.1c0.1,0.2,0.2,0.4,0.4,0.5 c0.4,0.9-0.3,1.4-0.7,1.7c-0.5,0.6,0.8,0.9,0.6,1.6c-0.1,0.9-0.6,0.7-0.6,1.3c0,0.6,0.4,0.4,0.4,1.3c0,0.8-0.5,0.8-0.4,1.2 c0.1,0.4,0.6,0.8,0.5,1.4c0.1,0.6,0.1,1.5,0.1,2c-0.3,0.6-0.7,0.7,0.1,2c0.4,0.4,0.1,0.8,0.1,1.2c0,0.4-0.7,1.2-0.1,2.1 c0,1.2-0.1,3.1-0.1,3.1s-0.4,1.5-1.1,1.5c1.9,0.1,5.6,0,5.6,0S35.9,57.4,35.9,56.5 M31.6,39.6l-0.1-0.1h0.3l0,0l-0.3-0.3 c0,0,0.8,0,1.6,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.3,0v0.1c0.1,0,0.3,0,0.3,0 c-0.1,0.3-0.2,0.9-0.9,0.9c-0.4,0-0.6-0.3-0.7-0.6c0,0-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.1,0c-0.2,0.5-0.5,0.7-0.8,0.8 C32.2,40.1,31.9,39.8,31.6,39.6 M31.8,42.3l-0.1-0.1c-0.1-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1,0,0.2,0.1l0.1,0.1 c0.2,0.3,0.4,0.6,0.6,0.6c0.2,0,0.4-0.2,0.8-0.6c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0.1,0.2,0.2,0.2,0.4c0.1,0.3,0.2,0.5,0.4,0.6 c0.5,0.1,0.7-0.2,0.8-0.6c-0.1,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0,0.2-0.1c-0.1,0.3-0.4,0.8-1.1,0.7c-0.4-0.1-0.5-0.4-0.6-0.7 c0,0-0.1-0.2-0.1-0.3c0,0-0.1,0.1-0.1,0.1c-0.3,0.4-0.7,0.7-0.9,0.6C32.3,43,32,42.6,31.8,42.3 M32,45.4h0.3l0,0L32,45.1 c0,0,0.8,0,1.6,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.3,0c0,0.1,0,0.1,0,0.1c0.1,0,0.3,0,0.3,0 c-0.1,0.3-0.2,0.9-0.9,0.9c-0.4,0-0.6-0.3-0.7-0.6c0,0-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.1,0C33.6,45.8,33.3,46,33,46 c-0.3,0.1-0.7-0.3-0.9-0.5L32,45.4z M31.9,49l-0.1-0.1H32l0,0l-0.3-0.3c0,0,0.8,0,1.6,0c0.1-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.3,0c0,0.1,0,0.1,0,0.1c0.1,0,0.2,0,0.2,0c-0.1,0.3-0.2,0.9-0.9,0.9c-0.4,0-0.6-0.3-0.7-0.6 c0,0-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.1,0c-0.2,0.5-0.5,0.7-0.8,0.8C32.4,49.6,32.1,49.3,31.9,49 M34.8,52.8c-0.4,0-0.6-0.3-0.7-0.6 c0,0-0.1-0.1-0.1-0.2h-0.1c-0.2,0.5-0.5,0.7-0.8,0.8c-0.3,0.1-0.7-0.2-0.9-0.5l-0.1-0.1h0.3l0,0l-0.3-0.3c0,0,0.8,0,1.6,0 c0.1-0.1,0.1-0.2,0.3-0.1c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.3,0s0,0.1,0,0.1c0.1,0,0.2,0,0.2,0C35.6,52.2,35.4,52.7,34.8,52.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.9818,
    y1: 33.765,
    x2: 35.1531,
    y2: 33.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M34,33.6c0.1,0.3,0.2,0.5,0.4,0.5c0.4,0,0.6-0.3,0.7-0.7C35,33.4,34.5,33.5,34,33.6C34,33.5,34,33.6,34,33.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.5082,
    y1: 18.3822,
    x2: 50.8853,
    y2: 18.3822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M33.6,33c0.2-0.3,0.4-0.1,0.8,0.1c0.3,0.2,1.3-0.1,1.3-0.3c0.1-0.3-0.2-0.9,0.3-1.1c0.5-0.1,0.9-0.6,0.9-0.9 c0.1-0.3,0.2-0.6,0.6-0.6c0.3-0.1,0.9-0.3,0.9-0.5S38.1,29,38.7,29c0.6,0.1,0.8-0.3,1.5,0.2c0.3,0.2,0.3-0.3,0.3-0.4 c-0.1-0.2,0.3-0.8,0.8-0.4c0.5,0.4,1.2,0.2,0.8-0.1c-0.4-0.3-0.2-0.8,0.4-0.7c0.6,0.1,1.3-0.2,1.5,0.2c0.2,0.4,0.7,0.3,0.6,0.1 c-0.1-0.2,0.4-0.1,0.6-0.1c0.2,0-0.1-0.3-0.3-0.4c-0.3-0.1-2.2-1.1-3.3-0.9c-0.6-0.4-0.7-0.4-0.7-0.7s-0.3-0.5,0-0.6 c0.3-0.1,0.4-0.3,0.9-0.1c0.5,0.2,0.6-0.4,0.2-0.6c-0.4-0.1,0.2-0.6,0.5-0.6c0.3-0.1,0.8-0.3,1.2-0.1c0.3,0.2,0.4-0.3-0.1-0.5 c-0.1-0.4,0.4-0.7,1.1-0.6c0.6,0.1,1.1-0.4,1.7,0c0.6,0.4,0.4-0.6,0.2-0.8c-0.3-0.2-0.2-0.6,0.5-0.8c0.7-0.2,1-0.1,1.5,0.2 c0.4,0.2,0.5-0.2,0.8,0c0.3,0.2,0.8-0.2,0.3-0.4c-0.6-0.2-0.1-0.5,0.2-0.5c0.3,0,1.2-0.2,1.3-0.2c0.1-0.1-0.8-0.2-2.1-0.2 c-1.2,0.1-5.1,0.8-6.9,2c0,0-4.1,2.6-5.9,5.4c-1.1,1.2-0.3-0.3,0-0.7c0.3-0.4,1.3-1.8,1.6-2.1c0.2-0.2,0.5-0.4,0.7-0.4 c0.2-0.1-0.1-1.1,0.4-1.3c0.6-0.2,0.8-0.2,0.9-0.2s0.1-0.4,0-0.8c-0.1-0.4,0-0.8,0.7-0.9c0.7-0.1,1.1-0.2,1.4-0.3 c0.3-0.1,0.6-0.3-0.4-0.4c-0.9-0.1,0.3-0.9,0.8-1.1c0.4-0.1,0.6-0.1,0.8-0.1c0.2,0,0.3-0.2,0-0.9c0.2-0.3,0.6-0.3,0.9-0.7 c0.3-0.3,0.6-0.6,0.9-0.3c0.3,0.2,0.9,0,0.6-0.3c-0.3-0.3-0.3-0.6,0.1-0.7c0.4-0.1,2.2-0.8,2.6-1.1c0.3-0.3,0-0.4-0.6-0.2 c-0.6,0.3-6.7,2.1-11.9,10.8c-0.7,1.1-1,0.4-0.7-0.7c0.4-0.9,1.2-2.1,1.5-2.5c0.3-0.4,1.1-0.8,0.5-1.5c0.6-0.3,0.8-0.7,0.9-0.9 c0.1-0.2,0.7-0.2,0.7-0.5c-0.1-0.3-0.3-0.1-0.6-0.4c-0.3-0.3,0-0.4,0.4-0.7s0.8-0.7,0.8-1.1c0.3-0.2,0.5-0.3,0.7-0.6 c0.2-0.2-1.7-0.3-0.6-1.1c1.1-0.8,1.7-1.1,2.1-1.2c0.4-0.2-0.1-0.4-0.6-0.6c-0.5-0.2-0.1-1.1,0.9-1.7c1.1-0.3,1.3-0.4,1.7-0.7 c0.3-0.2,0.2-0.7-0.3-0.6c-0.6,0.2-0.6-0.4,0.2-0.8c0.7-0.4,1.5-1.5,2.2-2s-0.3-0.3-0.6-0.1c-0.3,0.2-3.7,3-4.1,3.6 c-0.4,0.6-2.8,4-3.3,4.9s-2,2.6-2.1,0.9c-0.2-0.3-0.6-0.4-0.2-1.1c0.3-0.6,0.6-1.6,0.5-1.9c-0.1-0.3-0.5-0.1-0.6-0.8 c-0.1-0.7-0.1-1.2,0.3-1.7c0.3-0.4,0.7-0.9,0.2-1.1c-0.5-0.1-0.7-0.4-0.6-1.2c0.1-0.8,0-1.2,0.4-1.7c0.4-0.4,0.1-0.5-0.6-0.3 c-0.7,0.2,0.1-0.4,0.5-0.7c0.4-0.3,0.9-0.7,0.3-0.7c-0.6-0.1-0.6-0.3-0.3-1.1c0.3-0.7,0.3-1.1,0.3-1.5c0.1-0.4-0.8,1.3-1.2,2 C34,6.3,32.6,9.7,33,19.2c-0.1,0.4-0.4,0.4-1.1-0.4c-0.6-0.8-6.5-9-8.6-10.1c-0.8-0.1-0.4,0.2,0.1,0.6c0.5,0.4,2.5,2.1,1.8,2.1 c-0.6,0.4-0.1,0.7,0.4,0.7s2.3,1.5,1.7,2.1c-0.4,0.4,0.5,0.6,0.7,0.7c0.2,0.1,0.9,1,1,1.5c0.1,0.4-0.8,0.3-0.8,0.7 c0,0.3,0.7-0.1,0.6,0.2C28.7,17.4,28,17.8,29,18c0.9,0.3,1.1,0.6,1.2,1.2c0.1,0.6-0.1,0.7,0.3,0.9s0.7,0.3,0.8,0.8 c0.1,0.4-0.8,0.6-0.2,1c0.7,0.4,0.8,0.7,0.9,1.1c0.2,0.4,0.1,0.6,0.2,1.1c0.2,0.6,0.4,0.7,0.3,1.1c-0.1,0.4-0.7-0.4-1.2-1.2 c-0.4-0.7-6.5-8.8-13.4-9.5c-0.3,0.3,0.4,0.5,1.6,0.8c1.2,0.3,2.6,0.7,2.8,1c0.3,0.3-0.2,0.9,0.2,1c0.4,0.1,2.5,0.5,2.3,1.5 c-0.1,0.9,2,0.5,1.8,1.1c-0.2,0.7-0.2,1.2,1.2,1.2c0.3,0.7,0.4,0.9-0.1,1.3c-0.6,0.3,1.7,0.2,1.8,0.7c0.2,0.4-0.3,0.7-0.1,1 c0.2,0.3,0.8,0.2,1.3,0.8s1.8,1.8,1.8,2.3c0.1,0.5-0.2,0.3-0.7,0c-0.5-0.3-6.6-8.3-15.3-7c-0.8,0.4,0.1,0.3,0.3,0.3 c0.2,0,2.3,0,1.6,0.7c-0.8,0.7,4.7-0.2,2.8,1.1c-1.8,1.4,3.5-0.5,3.3,0.7c-2.6,1.3,2.5,0,1.6,1.4c-1.4,0.8,1.8,0.6,1.3,0.8 s-1,1.1-1,1.1s-3.1,0.2-3.5,1.1c-0.4,0.9,1.2,0.5,1.3,0.3c0.2-0.2,1.7-0.5,1.5,0.2c-0.2,0.7,0.4,0.6,0.7,0.4 c0.2-0.2,1.1-0.3,0.9,0.3c-0.1,0.6,0.2,0.7,0.6,0.3c0.3-0.3,0.7-0.2,1.3,0.1c0.7,0.2,1.1,0.4,1.3,1c0.3,0.6,0.4,1.2,0.8,1.2 c0.3,0.1,0.4,0.3,0.4,0.7s0.1,0.7,0.3,0.8C32.9,33.2,33.6,33,33.6,33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.7858,
    y1: 58.1831,
    x2: 54.8989,
    y2: 58.1831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M13.5,53.1c0.1,0.1,1.3,1.9,2.5,2.7c-0.6,0.3-1.7,0.5-3,0.5h-0.3l0.2,0.2c1.2,1.7,5,2.1,6.6,1.7 c0,0.1,0.1,0.2,0.1,0.3c0,0.4-0.1,0.9-0.3,1.2c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.2,0.1,0.4,0.2,0.6c5.5,3.8,20.9,2.7,27.1,0.7 c0.7-0.1,1.4-0.3,1.7-0.8c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2-0.1-0.5-0.1-0.8c-0.2-0.3-0.2-1-0.3-1.4c0.1,0,0.3,0,0.3,0 c2.8,0.1,4.9-0.5,6.4-1.8l0.3-0.3l-0.4,0.1c-0.7,0.1-2-0.1-3.2-0.6c1.2-0.7,2.5-1.6,2.6-2.6l0,0l0,0c0,0,0,0,0-0.1l-0.3-0.1 c-0.2,0.3-2.8,0.6-4.4,0.6c-0.7,0-1.3-0.1-2.2-0.3l-1.8-0.3c-1.3,0.2-1.6,0.6-1.6,0.9c0,0.4,0.5,0.8,0.9,0.9c0.4,0.1,0.9,0.1,1.5,0 l1-0.1c0.5,0,0.8,0.1,0.9,0.3c0,0.1,0,0.3-0.8,0.8c-5.1,2.5-23.4,2-26.9-0.2c-0.8-0.4-0.8-0.7-0.8-0.7c0.1-0.2,0.9-0.3,2.2-0.2 c0.8,0.1,1.7-0.2,2-0.6c0.1-0.2,0.1-0.3,0.1-0.5c-0.3-0.7-2.3-0.7-3-0.7l-1.3,0.2c-0.7,0.2-1.6,0.3-2.1,0.3c-1,0-2.3-0.3-3.7-0.9 l-0.4-0.2L13.5,53.1z M44.6,54.6c-0.3-0.1-0.7-0.4-0.7-0.7l0,0c0-0.3,0.5-0.6,1.3-0.7l1.8,0.3c0.9,0.2,1.6,0.3,2.2,0.3 c0.1,0,3.1-0.1,4.2-0.5c-0.3,0.8-1.5,1.6-2.6,2.3l-0.2,0.1l0.2,0.1c1,0.5,2.3,0.7,3.1,0.7c-1.4,1.1-3.3,1.6-5.9,1.5h-0.6v0.2 c0,0.1,0.1,1.2,0.3,1.6c0.2,0.6,0.2,1-0.1,1.3c-0.2,0.3-0.7,0.5-1.5,0.7c-6,2-21.5,3-26.9-0.7c-0.2-0.3-0.1-0.7,0.1-1.2 c0.2-0.5,0.4-1.1,0.2-1.9l-0.1-0.2l-0.2,0.1c-1.5,0.4-5,0.1-6.3-1.3c1.4,0,2.5-0.2,3-0.6l0.2-0.1l-0.2-0.1c-0.9-0.5-2-1.8-2.4-2.4 c1.3,0.4,2.5,0.7,3.4,0.7c0.6,0,1.5-0.2,2.2-0.3l1.2-0.2c0.8-0.1,2.6,0.1,2.7,0.4c0,0.1,0.1,0.1-0.1,0.2c-0.2,0.3-1.1,0.6-1.8,0.5 c-0.2,0-2.3-0.2-2.5,0.4c-0.1,0.3,0.2,0.6,0.9,1c3.6,2.1,22,2.6,27.2,0.2c0.7-0.4,1-0.8,0.9-1.2c-0.1-0.4-0.9-0.5-1.2-0.5l-1,0.1 C45.5,54.6,45,54.7,44.6,54.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.3119,
    y1: 56.6065,
    x2: 19.8139,
    y2: 56.6065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M19.8,58c0,0-0.1-1.6-0.3-2.8L19.8,58z M19.6,58L19.6,58c0,0-0.1-1.6-0.3-2.8L19.6,58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.5918,
    y1: 56.8575,
    x2: 48.0938,
    y2: 56.8575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M47.6,58.1l0.2-2.6C47.7,56.4,47.6,58.1,47.6,58.1 M48.1,55.6c-0.2,0.8-0.2,2.6-0.2,2.6L48.1,55.6L48.1,55.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.0778,
    y1: 55.714,
    x2: 44.5798,
    y2: 55.714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M44.4,54.6c0,0.4,0.2,2.2,0.2,2.2L44.4,54.6L44.4,54.6z M44.3,56.9l-0.2-2.3C44.1,55,44.3,56.7,44.3,56.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.826,
    y1: 55.6303,
    x2: 23.6069,
    y2: 55.6303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M22.8,56.7L22.8,56.7c0-0.1,0.4-1,0.5-2.3L22.8,56.7z M23.1,56.9c0-0.1,0.5-1.1,0.5-2.5L23.1,56.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.316,
    y1: 59.2507,
    x2: 22.2124,
    y2: 59.2507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M22,58.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.4-0.1-0.4,0.2c-0.1,0.4,0.9,0.6,0.6,1.3 c-0.2,0.4-0.6,0.5-1,0.4c-0.2-0.1-0.3-0.2-0.5-0.3l0.2-0.4c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.4,0.1,0.4-0.2 c0.2-0.4-0.8-0.6-0.6-1.3c0.2-0.5,0.6-0.5,0.9-0.4c0.2,0.1,0.3,0.2,0.5,0.3L22,58.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0451,
    y1: 59.6743,
    x2: 23.9268,
    y2: 59.6743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M22.7,58.3l0.4,0.1l-0.2,0.9l0,0c0.2-0.1,0.3-0.2,0.6-0.1c0.4,0.1,0.5,0.4,0.4,0.8l-0.3,1l-0.4-0.1l0.2-0.9 c0.1-0.2,0.1-0.4-0.2-0.6c-0.3-0.1-0.4,0.2-0.5,0.4l-0.2,0.8L22,60.6L22.7,58.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1395,
    y1: 60.5458,
    x2: 25.7038,
    y2: 60.5458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M24.7,61c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.2-0.3l-0.2-0.1c-0.2-0.1-0.5-0.1-0.6,0.2 C24.4,60.9,24.6,61,24.7,61 M24.5,59.6c0.2-0.1,0.4-0.1,0.6,0c0.5,0.1,0.7,0.3,0.6,0.8l-0.1,0.2c-0.1,0.2-0.1,0.3-0.1,0.4 s-0.1,0.2-0.1,0.4l-0.4-0.1c0-0.1,0-0.2,0.1-0.2l0,0c-0.1,0.2-0.4,0.2-0.6,0.2c-0.3-0.1-0.6-0.3-0.4-0.6c0.1-0.2,0.2-0.4,0.4-0.4 c0.2-0.1,0.4,0,0.6,0l0.2,0.1c0.1-0.3-0.1-0.4-0.3-0.4c-0.2-0.1-0.4,0-0.6,0.1L24.5,59.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.9496,
    y1: 60.762,
    x2: 27.1767,
    y2: 60.762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M26.2,59.9l0.4,0.1l-0.1,0.4l0,0c0.1-0.2,0.3-0.4,0.5-0.3c0.1,0,0.1,0,0.1,0.1l-0.1,0.4 c-0.1-0.1-0.1-0.1-0.2-0.1c-0.3-0.1-0.4,0.4-0.4,0.6l-0.1,0.6l-0.4-0.1L26.2,59.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8979,
    y1: 60.932,
    x2: 27.9577,
    y2: 60.932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M27.5,59.4l0.4,0.1l-0.1,0.4l-0.4-0.1L27.5,59.4z M27,62.1c0.2,0,0.3,0,0.3-0.3l0.2-1.7l0.4,0.1l-0.2,1.8 c-0.1,0.2-0.1,0.6-0.6,0.6c-0.1,0-0.2,0-0.2-0.1L27,62.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.1808,
    y1: 61.013,
    x2: 29.6952,
    y2: 61.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M28.9,61.6c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3h-0.2c-0.2,0-0.5,0-0.5,0.3 C28.6,61.5,28.7,61.6,28.9,61.6 M28.4,60.3c0.2-0.1,0.4-0.1,0.6-0.1c0.5,0,0.7,0.2,0.7,0.7v0.2c0,0.2,0,0.3,0,0.4 c0,0.1,0,0.2,0,0.4h-0.4c0-0.1,0-0.2,0-0.3l0,0c-0.1,0.2-0.3,0.3-0.6,0.3c-0.3,0-0.6-0.2-0.6-0.5c0-0.3,0.1-0.4,0.3-0.4 c0.2-0.1,0.4-0.1,0.6-0.1h0.2c0-0.3-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.5,0.2L28.4,60.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.0215,
    y1: 60.6783,
    x2: 31.9737,
    y2: 60.6783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M30,59.5l0.4-0.1l0.2,1l0,0c0.1-0.2,0.3-0.3,0.5-0.3c0.4-0.1,0.6,0.2,0.7,0.6l0.2,1.1l-0.4,0.1l-0.1-0.9 c0-0.2-0.1-0.5-0.3-0.4c-0.3,0.1-0.3,0.4-0.3,0.6l0.1,0.8l-0.4,0.1L30,59.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.8546,
    y1: 59.5815,
    x2: 46.6977,
    y2: 59.5815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M43.9,61.4c0.3,0.1,1.2,0.2,1.6,0.1c0.6-0.2,1-0.9,1.1-1.4c0.2-0.6,0.2-1.6-0.2-2.3c0,0,0-0.1-0.1-0.1 c0-0.1-0.1-0.2-0.1-0.1c-0.1,0.2-0.1,0.4-0.1,0.4s0,0.3-0.1,0.4c0,0.1-0.1,0.3-0.2,0.4c0,0.1-0.1,0.3,0,0.3s0.1-0.1,0.2-0.2 c0.1-0.2,0.1-0.5,0.2-0.8c0.2,0.4,0.4,1.3,0.2,1.8c-0.1,0.4-0.6,1-0.8,1.1C45.2,61.4,43.9,61.4,43.9,61.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.8546,
    y1: 59.5775,
    x2: 46.6977,
    y2: 59.5775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M46.2,57.6L46.1,58v0.1v0.1L46,58.5L46,58.6l-0.1,0.2c0,0.1-0.1,0.3,0.1,0.3l0,0H46c0.1-0.1,0.1-0.1,0.1-0.2 l0.2-0.8c0.2,0.3,0.3,1.3,0.2,1.8c-0.1,0.4-0.6,1-0.8,1.1c-0.4,0.3-1.8,0.3-1.8,0.3v0.1c0.4,0.1,1.2,0.2,1.6,0.1 c0.6-0.2,1-1,1.1-1.5c0.2-0.6,0.2-1.6-0.2-2.3l-0.1-0.1c0-0.1,0-0.1-0.1-0.1C46.3,57.5,46.3,57.5,46.2,57.6 M46.1,58l0.1-0.4 c0-0.1,0.1-0.1,0.1-0.1s0.1,0.1,0,0.1l0.1,0.2c0.3,0.7,0.3,1.7,0.2,2.3c-0.1,0.4-0.6,1.2-1.1,1.4c-0.4,0.1-1,0.1-1.4,0 c0.4,0,1.2-0.1,1.6-0.3c0.3-0.1,0.8-0.7,0.8-1.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.5-0.1-1.1-0.3-1.4c-0.1,0-0.2,0.8-0.2,0.8 c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.1-0.1-0.1-0.3l0.1-0.2l0.1-0.2l0.1-0.3v-0.1C46.1,58.1,46.1,58,46.1,58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8345,
    y1: 60.056,
    x2: 44.9791,
    y2: 60.056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M45,58.6c0,0.2-0.1,1.2-0.2,1.3c-0.1,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0.1-0.2,0.2 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2-0.1-0.2-0.1s-0.1,0.1-0.2,0.2s-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3-0.1 c-0.5,0.6-0.7,0.8-1.1,1c-0.5,0.3-1,0.4-1.5,0.4c-0.4,0-1.1-0.4-1.1-1.6c0.1-0.9,0.1-1.2,0.1-1.5c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.2-0.2-0.1c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.2-0.3,0.2,0.1c0,0.3-0.1,1.1-0.1,1.2 c0,0.2-0.1,0.5-0.1,0.6c0,0.4-0.1,1.3,0.6,1.6c0.8,0.1,1.3-0.1,1.6-0.3c0.3-0.2,0.8-0.4,1.1-0.9c0.1-0.1,0.2-0.2,0.3,0 c0.1,0.1,0.1,0,0.2-0.1s0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.2,0.1,0.4-0.2c0.1-0.2,0.1-0.8,0.1-0.9c0-0.1-0.1-0.1-0.1,0s-0.1,0.3-0.2,0.4 c-0.1,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.3,0.1-0.4c0.1-0.2,0.3-0.6,0.3-0.7c0.1-0.1,0.2-0.1,0.2,0.1 C45,58.3,45,58.6,45,58.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.723,
    y1: 60.0369,
    x2: 45.026,
    y2: 60.0369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M44.7,58l-0.2,0.4l-0.2,0.3l-0.1,0.4c0,0.1,0,0.1,0.1,0.1s0.1-0.1,0.1-0.1l0.1-0.1l0.2-0.4 c0-0.1-0.1,0.9-0.1,0.9c-0.2,0.3-0.2,0.2-0.3,0.2l-0.2-0.1l-0.2,0.2L43.8,60c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2-0.1-0.2-0.1-0.3,0 l-0.2,0.2C43,60.5,43,60.5,43,60.5c-0.1-0.1-0.1-0.2-0.2-0.2s-0.2,0.1-0.2,0.1c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.8,0.4-1.6,0.3 c-0.7-0.2-0.6-1.1-0.6-1.5c0-0.1,0.1-0.6,0.1-0.6v-0.3l0.1-1c0-0.2-0.1-0.2-0.1-0.2c-0.1,0-0.1,0.1-0.2,0.2l-0.2,0.6l-0.1,0.1 l-0.2,0.4c0,0.2,0,0.2,0.1,0.2s0.1-0.1,0.2-0.1c0,0,0.1-0.2,0.2-0.2l-0.1,0.4L39,60.7c0,0.7,0.2,1.1,0.4,1.3 c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1.1-0.2,1.5-0.4c0.3-0.2,0.6-0.4,1.1-1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1 c0.1-0.1,0.2-0.2,0.2-0.2l0.2-0.2c0,0.1,0.2,0.1,0.2,0.1c0.3,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.1,0.2-0.1l0.3,0.1 c0.1,0,0.2-0.2,0.3-0.3c0.1-0.2,0.2-1.2,0.2-1.4v-0.5c-0.1-0.1-0.1-0.2-0.2-0.2C44.8,57.9,44.8,57.9,44.7,58 M44.4,59.1l0.1-0.4 l0.2-0.3l0.2-0.4c0.1-0.1,0.1-0.1,0.1-0.1S45,58,45,58.1v0.5c0,0.2-0.1,1.2-0.2,1.3L44.8,60c-0.1,0.1-0.2,0.2-0.2,0.3l-0.3-0.1 c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.2-0.2,0.3-0.4,0.3l-0.1-0.1h-0.1l-0.1,0.2l-0.2,0.2c-0.1,0.1-0.1,0.1-0.1,0.1 c-0.1,0-0.1-0.1-0.1-0.1c-0.5,0.6-0.8,0.8-1.2,0.9c-0.4,0.3-0.9,0.4-1.5,0.4c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.2-0.4-0.6-0.4-1.2 l0.1-1.1l0.1-0.5l-0.1,0.1l-0.2,0.2c-0.1,0.1-0.1,0.1-0.1,0.1s-0.1,0-0.1-0.2l0.2-0.4l0.1-0.1l0.2-0.6c0.1-0.1,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0.2l-0.1,1v0.3l-0.1,0.6c-0.1,0.4-0.1,1.3,0.7,1.6c0.8,0.1,1.2-0.1,1.6-0.3c0.4-0.2,0.8-0.5,1.1-0.9 c0.1-0.1,0.1-0.1,0.2-0.1s0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.2-0.1l0.2-0.2c0.1-0.1,0.1-0.1,0.2,0 c0.2,0.1,0.3-0.1,0.3-0.2l0.1-0.2l0.1-0.1l0.2,0.1c0.2,0.1,0.3,0.1,0.4-0.2l0.1-0.9h-0.1l-0.2,0.4l-0.1,0.1l-0.1,0.1 C44.4,59.1,44.4,59.1,44.4,59.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2759,
    y1: 61.1524,
    x2: 43.9313,
    y2: 61.1524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M43.6,61.1c-0.1,0.1-0.1,0.1-0.1,0.1S43.6,61.2,43.6,61.1c0.1,0,0.1-0.1,0.1-0.1C43.7,61,43.6,61,43.6,61.1  M43.9,60.8c0.1,0.1,0,0.3-0.2,0.4s-0.3,0.3-0.4,0.2c-0.1-0.1,0-0.3,0.2-0.4C43.6,60.9,43.9,60.8,43.9,60.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.52,
    y1: 61.0967,
    x2: 43.7431,
    y2: 61.0967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M43.6,61l-0.1,0.1c0.1,0.1,0.1,0,0.2-0.1s0.1-0.1,0.1-0.1C43.7,61,43.6,61,43.6,61 M43.6,61.2 c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0.1-0.1,0.1C43.6,61.2,43.6,61.2,43.6,61.2 M43.6,61L43.6,61L43.6,61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2411,
    y1: 61.1416,
    x2: 43.9662,
    y2: 61.1416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M43.5,61c-0.1,0.2-0.2,0.3-0.2,0.4l0,0l0.1,0.1c0.1,0.1,0.3-0.1,0.4-0.2c0.1-0.2,0.2-0.3,0.2-0.4l0,0 l-0.1-0.1C43.8,60.7,43.6,60.9,43.5,61 M43.3,61.5c0-0.1,0.1-0.2,0.2-0.4c0.2-0.2,0.3-0.3,0.4-0.2v0.1c0,0.1-0.1,0.2-0.2,0.4 C43.5,61.4,43.4,61.5,43.3,61.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4448,
    y1: 59.609,
    x2: 42.1255,
    y2: 59.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M41.6,59.9c0.1-0.2,0.4-0.1,0.5-0.3c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2-0.1-0.1c-0.1,0.1-0.1,0.1-0.1,0.2 c-0.1,0.1-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3C41.4,60.1,41.6,59.9,41.6,59.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4004,
    y1: 59.5906,
    x2: 42.1255,
    y2: 59.5906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M42,59.3l-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.1h-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.2,0.1,0.2 s0.1-0.1,0.1-0.1l0,0c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1l0.1-0.2c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1 C42.1,59.3,42,59.3,42,59.3 M41.9,59.5c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.1s0,0,0,0.1S42,59.5,42,59.5 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.2l0,0c0,0.1-0.1,0.1-0.1,0.1s0,0,0-0.1v0.1c0-0.1,0.1-0.2,0.2-0.3h0.1 C41.7,59.5,41.8,59.5,41.9,59.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3378,
    y1: 58.4579,
    x2: 44.148,
    y2: 58.4579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M43.5,58.8c-0.1,0.2-0.2,0.2-0.2-0.1c0.1-0.3,0.4-0.6,0.6-0.6c0.2,0,0.3,0.2,0.2,0.4 c-0.1,0.2-0.2,0.4-0.3,0.2C43.6,58.6,43.6,58.7,43.5,58.8C43.5,58.7,43.5,58.8,43.5,58.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.255,
    y1: 58.4472,
    x2: 44.1196,
    y2: 58.4472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M43.9,58c-0.2,0-0.5,0.3-0.6,0.7c-0.1,0.2-0.1,0.3,0,0.3s0.2-0.1,0.2-0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.1 c0.1,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.2-0.2l0.1-0.1c0.1-0.1,0.1-0.2,0-0.3C44.1,58,44,58,43.9,58 M43.4,58.9c0,0-0.1,0,0-0.2 c0.1-0.3,0.4-0.6,0.6-0.6c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0,0.2L44,58.5c-0.1,0.1-0.1,0.2-0.2,0.2s-0.1,0-0.1-0.1 c-0.2-0.1-0.2,0-0.2,0.1l-0.1,0.1l0,0C43.4,58.8,43.4,58.9,43.4,58.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.8305,
    y1: 62.2122,
    x2: 38.8345,
    y2: 62.2122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M38.8,61.8c-0.1-0.1-0.1-0.1-0.1,0l-0.8,0.7c0,0,0,0.1,0,0.1l0.1,0.1c0.1,0.1,0.1,0.1,0.1,0l0.8-0.7 C38.8,61.9,38.8,61.9,38.8,61.8L38.8,61.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0774,
    y1: 61.2552,
    x2: 38.796,
    y2: 61.2552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M36.3,62.4c0.2,0,1.2,0,1.7-0.6c0.6-0.6,0.3-0.8,0.6-1.1c0.1,0,0.1,0.2,0.2,0s0.2-0.6,0-0.7 c-0.2-0.1-0.5,0.3-0.6,0.6c-0.1,0.3-0.2,0.9-1.2,1.2c-0.3,0.2-0.5,0.2-0.7,0.2C35.9,62.4,36.3,62.4,36.3,62.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.4608,
    y1: 58.9957,
    x2: 37.2385,
    y2: 58.9957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M36.5,59c-0.1,0.1-0.1,0.3,0.2,0.2c0.2-0.1,0.4,0,0.5-0.2c0.1-0.2,0.2-0.4-0.2-0.3c-0.2,0.1-0.3,0-0.4,0.2 C36.5,58.9,36.5,59,36.5,59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0281,
    y1: 59.5604,
    x2: 36.5554,
    y2: 59.5604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M36.1,59.5c-0.1,0.1-0.1,0.3,0.1,0.2c0.2-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.3-0.2-0.2 C36.2,59.5,36.1,59.5,36.1,59.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.3056,
    y1: 60.716,
    x2: 37.0496,
    y2: 60.716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M36.5,60.4C36.5,60.4,36.5,60.4,36.5,60.4v0.1C36.6,60.5,36.6,60.5,36.5,60.4C36.7,60.4,36.6,60.4,36.5,60.4  M37,60.6c-0.1,0.4-0.3,0.8-0.7,0.8c-0.2,0-0.3-0.2-0.4,0c-0.2,0.1-0.7,0.8-0.9,0.9c-0.3,0.1-0.6,0.1-0.7-0.3 c-0.1-0.3,0.1-0.8,0.3-0.9c0.5-0.4,0.8-0.6,0.9-1.2C35.5,60,35.3,60,35.2,60c-0.2,0.1-0.2-0.2,0-0.6c0.2-0.1,0.3-0.1,0.3-0.1 c0.1-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.2-0.2,0.2,0c0,0.2-0.1,0.7-0.2,0.9c-0.1,0.2-0.2,0.6-0.4,0.8c-0.2,0.2-0.6,0.4-0.7,0.6 c-0.1,0.2-0.3,0.5,0.2,0.4c0.3-0.3,0.7-0.6,0.8-0.8c0.1-0.2,0.4-0.3,0.5-0.2c0.1,0.1,0.2,0.1,0.3,0c-0.1,0-0.4-0.1-0.2-0.6 c0.2-0.6,0.5-0.4,0.6-0.3c0.1,0.1,0.2,0.2,0.2,0.5C37,60.5,37,60.6,37,60.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomic);
export default __webpack_public_path__ + "static/media/economic.727f3982a7d39e80912a0d81327d64c7.svg";
export { ForwardRef as ReactComponent };